import { toString30pk9tzaqopn as toString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var AuthHookDataClass;
function AuthHookData() {
  if (AuthHookDataClass === VOID) {
    class $ {
      constructor(user, authenticated, loading, error, loginWithRedirect, getIdTokenClaims, logout, getAccessTokenSilently) {
        this.w3s_1 = user;
        this.x3s_1 = authenticated;
        this.y3s_1 = loading;
        this.z3s_1 = error;
        this.a3t_1 = loginWithRedirect;
        this.b3t_1 = getIdTokenClaims;
        this.c3t_1 = logout;
        this.d3t_1 = getAccessTokenSilently;
      }
      ef() {
        return this.x3s_1;
      }
      e3t() {
        return this.y3s_1;
      }
      toString() {
        return 'AuthHookData(user=' + toString(this.w3s_1) + ', authenticated=' + this.x3s_1 + ', loading=' + this.y3s_1 + ', error=' + toString(this.z3s_1) + ', loginWithRedirect=' + toString_0(this.a3t_1) + ', getIdTokenClaims=' + toString_0(this.b3t_1) + ', logout=' + toString_0(this.c3t_1) + ', getAccessTokenSilently=' + toString_0(this.d3t_1) + ')';
      }
      hashCode() {
        var result = this.w3s_1 == null ? 0 : hashCode(this.w3s_1);
        result = imul(result, 31) + getBooleanHashCode(this.x3s_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.y3s_1) | 0;
        result = imul(result, 31) + (this.z3s_1 == null ? 0 : hashCode(this.z3s_1)) | 0;
        result = imul(result, 31) + hashCode(this.a3t_1) | 0;
        result = imul(result, 31) + hashCode(this.b3t_1) | 0;
        result = imul(result, 31) + hashCode(this.c3t_1) | 0;
        result = imul(result, 31) + hashCode(this.d3t_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthHookData()))
          return false;
        if (!equals(this.w3s_1, other.w3s_1))
          return false;
        if (!(this.x3s_1 === other.x3s_1))
          return false;
        if (!(this.y3s_1 === other.y3s_1))
          return false;
        if (!equals(this.z3s_1, other.z3s_1))
          return false;
        if (!equals(this.a3t_1, other.a3t_1))
          return false;
        if (!equals(this.b3t_1, other.b3t_1))
          return false;
        if (!equals(this.c3t_1, other.c3t_1))
          return false;
        if (!equals(this.d3t_1, other.d3t_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AuthHookData');
    AuthHookDataClass = $;
  }
  return AuthHookDataClass;
}
//region block: exports
export {
  AuthHookData as AuthHookData2x0lxghdz8ao,
};
//endregion

//# sourceMappingURL=AuthHookData.mjs.map
